module.exports = __webpack_public_path__ + "static/media/archive-icon.7f7a2c6a.svg";